// src/lib/translationDomGuard.ts
// Browservertaling (Google Translate in Chrome/Edge) vervangt tekstnodes door
// <font>-elementen. React 18 verwacht dat zijn eigen DOM-nodes onaangeraakt
// blijven en crasht dan bij reconciliatie met een NotFoundError op
// insertBefore/removeChild — de gebruiker ziet het volledige foutscherm
// (React issue #11538; bij ons gezien op /login, /mailinglist en
// /dashboard/settings bij Windows-gebruikers met autovertaling).
// Deze guard vangt precies dat geval af zodat vertaling bruikbaar blijft:
// de bewuste DOM-operatie wordt overgeslagen in plaats van te crashen.

export function installTranslationDomGuard(): void {
  if (typeof Node !== 'function' || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      console.warn(
        '[translationDomGuard] removeChild overgeslagen: node is geen kind meer (vermoedelijk browservertaling)'
      );
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn(
        '[translationDomGuard] insertBefore overgeslagen: referentienode is geen kind meer (vermoedelijk browservertaling)'
      );
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
